!<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <vs-button
        radius
        @click.stop="back()"
        class="float-left mr-2"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
      ></vs-button>

      <span class="font">{{ users.name }}</span>
    </div>
    <!-- <div class="ml-auto md:block">
      <vs-button color="danger" icon-pack="feather">Deactivate</vs-button>
    </div> -->

    <vx-card class="mt-4">
      <vs-tabs vs-alignment="fixed">
        <vs-tab :label="$t('labels.profile_details')">
          <vs-row vs-w="12">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-avatar
                class="mx-auto"
                size="100px"
                :src="users.profile_pic"
              />
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <h2>{{ users.name }}</h2>
              <p>{{ users.email }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-divider></vs-divider>
          <vs-row vs-w="12" class="mb-3" v-if="users.facebook_profile_id">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.facebook_id") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.facebook_profile_id }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3" v-if="users.google_profile_id">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.google_id") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.google_profile_id }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3" v-if="users.apple_profile_id">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.apple_id") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.apple_profile_id }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>

          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.city") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.city + ", " + users.zipcode }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.interest") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <span>{{ users.interests | interest }}</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.experience_expertise") }} : </b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="6"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <!-- <a href="http://localhost:8080/img/user-09.ed018c7b.jpg" target="_blank"><vs-avatar class="mx-auto" size="100px" :src="require(`@/assets/images/profile/user-uploads/user-09.jpg`)" /></a> -->
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-col
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="4"
            vs-xs="12"
            v-for="(key, value) in users.teacher_details.experience_experties" :key="value"
          >
            <p>
              <b>{{ key.title }}</b>
            </p>
            <p>{{ key.years }}</p>
            <p>
              <a :href="key.certification" target="_blank"
                ><vs-avatar
                  class="mx-auto"
                  size="100px"
                  :src="key.certification"
              /></a>
            </p>
          </vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="4"
            vs-xs="12"
          >
            <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
          </vs-col>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    users: [],
    facebook: 0,
    google: 0,
    apple: 0,
    page:null,
  }),
  mounted() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    axios 
      .get("admin/teacherById/" + this.$route.params.id)
      .then((response) => {
        // let data = response.data.data;
        this.users = response.data.data[0];
        console.log(this.users);
      })
      .catch((err) => console.log(err.response));
  },
  methods: {
    back() {
      if(this.page){
         this.$router.push({ name: "Teachers", query: { page: this.page } });
        // this.$router.push({name: "Students",params:{page:this.page}});
      }
      else{ 
       history.back();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>